export const staticTexts = (lang) => {
  if (lang === "en") {
    return {
      NUMBER_ARRAY: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
      saveToRead: "Save to read on any device",
      localNews: "Local news",
      search: "Search",
      "e-mail": "e-mail",
      downloadMobileApps: "Download mobile apps",
      newsYouCommented: "No saved items here",
      newsYouSaved: "No saved items here",
      editProfile: "Edit Profile",
      saveToReadLater: "Save to read later",
      alsoRead: "Also Read",
      searchBoxText: "Search",
      language: "English",
      edition: "Edition",
      loadMore: "Load More",
      more: "Load More",
      relatedStories: "Related stories",
      morePhotoStories: "Related photos",
      readMore: "Read More",
      advertising: "Advertisement",
      publishedAt: "Published",
      updatedAt: "Updated",
      section: "Section",
      district: "District",
      upazila: "Upazila",
      tag: "Topic",
      filterText: "Filter",
      filterClearText: "Reset Filter",
      author: "Author",
      notifications: "Notifications",
      advanceSearch: "Search",
      sekasana: "Section",
      news: "News",
      sortOder: "Sort by",
      date: "Date Range",
      advanceSearchBox: "Search",
      resultsObtained: "The Results Obtained",
      breakingNews: "Breaking News",
      download: "Download",
      storyTypes: "Story Types",
      fromTheDate: "Start date",
      upToNow: "End Date",
      shareOnFacebook: "Share on Facebook",
      pleaseEmail: "Email",
      copyLink: "Copy link",
      print: "Print",
      shareOnLinkedIn: "Share on LinkedIn",
      shareOnTwitter: "Share on Twitter",
      shareOnWatsapp: "Share on Watsapp",
      shareOnInsta: "Share on Instagram",
      share: "Share",
      noResultsFound: "No Results Found",
      noResultsBreif:
        "The object you are looking for could not be found. This topic is probably not related " +
        "to Prothom Alo or you are searching incorrectly. Please be sure about your search topic.",
      cover: "Back to Home",
      nextVideo: "Next Video",
      readComments: "Read Comments",
      doComment: "Post Comment",
      yourCommentsWillBeSeenHere: "Your comments will show here.",
      save: "SAVE",
      logOut: "Log Out",
      savedPageTitle: "Saved Items",
      savedPageSubTitle: "Your saved item(s) have been added to your reading list. You can access on any device",
      seeAll: "See All",
      commentApproved: "Your comment has been published",
      commentAwaitingApproval: "Awaiting approval",
      liveText: "Live",
      liveEndText: "Live end",
      fewMomentsAgo: "Few moments ago",
      oneMinuteAgo: "1 minute ago",
      minutesAgo: "minutes ago",
      oneHourAgo: "1 hour ago",
      hoursAgo: "hours ago",
      detailsText: "Details...",
      newsletterText: "Newsletter",
      subscribeText: "Subscribe",
      followUsText: "Follow us",
      searchMetaTitle: "Search News - Bangladesh, Education, Youth - Prothom Alo English",
      searchMetaDescription:
        "Search Bangladesh, World, Sports, Opinion, Business, Youth, Entertainment, Lifestyle, Science & Technology, Video, Photo, Corporate, Environment Latest News",
      notificationMetaTitle: "Notification - Latest News on Notification | Prothom Alo English",
      notificationMetaDescription:
        "Get latest updates on Notification. Read Notification Breaking News in English, see exclusive videos and photos only on Prothom Alo English",
    };
  } else {
    return {
      NUMBER_ARRAY: ["০", "১", "২", "৩", "৪", "৫", "৬", "৭", "৮", "৯"],
      saveToRead: "খবর সংরক্ষণ করে যেকোনো সময় যেকোনো ডিভাইস থেকে পড়তে পারবেন",
      localNews: "আমার এলাকার খবর",
      search: "খুঁজুন",
      "e-mail": "ই-মেইল",
      downloadMobileApps: "মোবাইল অ্যাপস ডাউনলোড করুন",
      newsYouCommented: "সংরক্ষিত কোন আইটেম নাই",
      newsYouSaved: "সংরক্ষিত কোন আইটেম নাই",
      editProfile: "এডিট প্রোফাইল",
      saveToReadLater: "পরবর্তীতে পড়ার জন্য সংরক্ষণ",
      alsoRead: "আরও পড়ুন",
      searchBoxText: " যা খুঁজতে চান",
      language: "বাংলা",
      edition: "সংস্করণ",
      loadMore: "আরও খবর",
      more: "আরও",
      relatedStories: "এ সম্পর্কিত আরও পড়ুন",
      morePhotoStories: "এ সম্পর্কিত আরও ছবি দেখুন",
      readMore: "আরও পড়ুন",
      advertising: "বিজ্ঞাপন",
      publishedAt: "প্রকাশ",
      updatedAt: "আপডেট",
      section: "বিভাগ",
      district: "জেলা",
      upazila: "উপজেলা",
      tag: "বিষয়",
      filterText: "বাছাই করুন",
      filterClearText: "মুছে ফেলুন",
      author: "লেখক",
      notifications: "নোটিফিকেশন",
      advanceSearch: "অনুসন্ধান",
      sekasana: "সেকশন",
      news: "খবর",
      sortOder: "সাজানো",
      date: "তারিখ",
      advanceSearchBox: "অনুসন্ধান করুন",
      resultsObtained: "প্রাপ্ত ফলাফল",
      breakingNews: "এইমাত্র পাওয়া",
      download: "ডাউনলোড",
      storyTypes: "ধরন",
      fromTheDate: "শুরুর তারিখ",
      upToNow: "শেষ তারিখ",
      shareOnFacebook: "ফেসবুকে শেয়ার করুন",
      pleaseEmail: "ইমেইল করুন",
      copyLink: "খবরের লিংক কপি করুন",
      print: "প্রিন্ট করুন",
      shareOnLinkedIn: "লিংকডইনে শেয়ার করুন",
      shareOnTwitter: "টুইটারে শেয়ার করুন",
      shareOnWatsapp: "ওয়াটসঅ্যাপে শেয়ার করুন",
      shareOnInsta: "ইনস্টাগ্রামে শেয়ার করুন",
      share: "শেয়ার",
      noResultsFound: "কিছু পাওয়া যায়নি",
      noResultsBreif:
        "আপনি যা খুঁজছেন, তা পাওয়া যায়নি। বিষয়টি সম্ভবত প্রথম আলোর নয় কিংবা আপনি ভুলভাবে খুঁজছেন। " +
        "দয়া করে, বিষয়টি সম্পর্কে নিশ্চিত হয়ে নিন।",
      cover: "প্রচ্ছদে ফিরে যান",
      nextVideo: "পরবর্তী ভিডিও",
      readComments: "মন্তব্য পড়ুন",
      doComment: "মন্তব্য করুন",
      yourCommentsWillBeSeenHere: "আপনার করা মন্তব্য এখানে পাওয়া যাবে",
      save: "সংরক্ষণ",
      logOut: "লগ আউট",
      savedPageTitle: "আপনার সংরক্ষিত খবর",
      savedPageSubTitle:
        "আপনার সংরক্ষণ করা গল্পগুলি আপনার পঠন তালিকায় যুক্ত করা হয়েছে। যে কোনও ডিভাইসে অ্যাক্সেস করুন।",
      seeAll: "সব দেখুন",
      commentApproved: "আপনার মন্তব্য প্রকাশিত হয়েছে",
      commentAwaitingApproval: "অনুমোদনের জন্য অপেক্ষমান",
      liveText: "সরাসরি",
      liveEndText: "সম্প্রচার শেষ",
      fewMomentsAgo: "কিছুক্ষণ আগে",
      oneMinuteAgo: "১ মিনিট আগে",
      minutesAgo: "মিনিট আগে",
      oneHourAgo: "১ ঘণ্টা আগে",
      hoursAgo: "ঘণ্টা আগে",
      detailsText: "বিস্তারিত...",
      newsletterText: "প্রথমআলো নিউজ লেটার",
      subscribeText: "সাবস্ক্রাইব",
      followUsText: "আমাদের সঙ্গে থাকুন",
      searchMetaTitle: "নিউজ সার্চ - রাজনীতি, বাংলাদেশ, খেলা, বিনোদন, ছবি ও ভিডিও",
      searchMetaDescription:
        "নিউজ সার্চ করুন - বাংলাদেশ, রাজনীতি, খেলা, বিনোদন, বাণিজ্য, বিশ্ব, লাইফস্টাইল, জীবনযাপন, মতামত, চাকরি, শিক্ষা, ফিচার, বিজ্ঞান ও প্রযুক্তি এর খবর",
      notificationMetaTitle: "নোটিফিকেশন নিউজ - আপডেট ব্রেকিং নিউজ",
      notificationMetaDescription:
        "আপডেট ব্রেকিং নোটিফিকেশন নিউজ - ভিডিও, ছবি, বাংলাদেশ, খেলা, বিনোদন, রাজনীতি, বাণিজ্য, বিশ্ব, লাইফস্টাইল, ফিচার, শিক্ষা, বিজ্ঞান ও প্রযুক্তি",
    };
  }
};
